import React from "react";

import { MainContainer, ContainerIFrame, ContainerBody } from "./styles";
import Spinner from "react-bootstrap/Spinner";
import {
    getPacientesByEmpresaId
} from "../../../services/firebase/pacientes/index";
import { useSelector } from "react-redux";
import {
  Tabla,
  TablaHeader,
  TablaHeaderTexto,
  TablaBody,
  TablaBodyTexto,
  ContainerTitle,
  ContainerTitleText,
  FlexContainer,
  StyledInput,
  StyledButton,
  ContainerBtn,
} from "./styles";
import { getPacientesByIds } from "../../../services/firebase/pacientes";
const getFecha = (fecha) => {
  const a = fecha.getFullYear();
  const m = (fecha.getMonth() + 1).toString().padStart(2, "0");
  const d = fecha.getDate().toString().padStart(2, "0");
  return `${a}-${m}-${d}`;
};

export const PacientesRpt = () => {
const empresa = useSelector((state) => state.empresa);
const pacientes = useSelector((state) => state.pacientes);
const [estado, setEstado] = React.useState({
    loading: false,
    data: [],
    err: "",
  });

  React.useEffect(() => {
    async function fetchData() {
      try {
        setEstado({ ...estado, loading: true });
        let data = await getPacientesByEmpresaId(empresa.id);
        setEstado({ ...estado, data: data, loading: false });
      } catch (err) {
        setEstado({ ...estado, err: err.message, loading: false });
      }
    }
    fetchData();
  }, [empresa.id]); // Dependency on empresa.id to refetch if it changes
  



  if (estado.loading)
    return (
      <MainContainer>
        <Spinner animation="border" role="status">
          <span className="visually-hidden"></span>
        </Spinner>
      </MainContainer>
    );
  if (estado.err) return <div>{estado.err}</div>;
  return (
    <>
      <MainContainer>
        <ContainerTitle>
          <ContainerTitleText>Pacientes</ContainerTitleText>
        </ContainerTitle>
        <ContainerBody>
          


          <div className="py-2">
            {
              <Tabla>
                <TablaHeader>
                  <tr>
                    <TablaHeaderTexto scope="col">Paciente</TablaHeaderTexto>
                    <TablaHeaderTexto scope="col">DNI</TablaHeaderTexto>
                    <TablaHeaderTexto scope="col">Telefono</TablaHeaderTexto>
                  </tr>
                </TablaHeader>
                <TablaBody>
                  {estado.data
                    .map((item) => (
                      <tr key={item}>
                        <TablaBodyTexto data-label="Paciente">
                          {`${item.nombres} ${item.apellidos}`}
                        </TablaBodyTexto>
                        <TablaBodyTexto data-label="DNI">
                          {item.numDoc}
                        </TablaBodyTexto>
                        <TablaBodyTexto data-label="Telefono">
                          {item.telefono}
                        </TablaBodyTexto>
                      </tr>
                    ))}
                  </TablaBody>
              </Tabla>
            }
          </div>
        </ContainerBody>
        {/* <IFrame src={url} frameborder="0" scrolling="no"></IFrame> */}
      </MainContainer>
    </>
  );
};